// @ts-nocheck
/* eslint-disable lit/no-value-attribute */
import { html, css } from 'lit';
import JhaFormInput from '../jha-form-input-base/JhaFormInput.js';
import '../../icons/jha-icon-date.js';
import { jhaStyles } from '../../styles/jha-styles.js';

const styles = css`
  :host {
    display: block;
    margin-bottom: 16px;
  }
  :host([outline]) {
    --jha-input-padding: 17px 12px;
  }
  :host([outline][small]) {
    --jha-input-padding: 9px 10px;
  }
  :host([outline][small]) jha-icon-date,
  jha-icon-date {
    position: absolute;
    top: var(--jha-form-date-input-icon-top, 20px);
    bottom: var(--jha-form-date-input-icon-bottom, auto);
    right: 10px;
    fill: var(--jha-text-light, var(--body-text-secondary-color));
    pointer-events: none;
  }
  :host([small]) jha-icon-date {
    bottom: var(
      --jha-form-date-input-small-icon-bottom,
      var(--jha-form-date-input-icon-bottom, auto)
    );
  }
  :host([outline]:not[small]) input {
    height: 56px;
  }
  :host([outline]) jha-icon-date {
    top: var(--jha-form-date-input-icon-top, 28px);
  }
  jha-form-floating-group[has-focus] jha-icon-date-outline {
    fill: var(--jha-text-theme, #3aaeda);
  }
  [type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
    margin-right: 12px;
  }
  :host([outline]) [type='date']::-webkit-calendar-picker-indicator {
    margin: 0;
  }
  label {
    background-color: var(--jha-component-background-color, #fff);
    overflow: hidden;
    width: calc(100% - 54px);
  }
  :host([outline]) jha-form-floating-group[has-focus] label,
  :host([outline]) jha-form-floating-group[has-value] label {
    width: auto;
  }
  :host([filled]:not([outline])) label {
    background-color: var(
      --jha-color-light,
      var(--secondary-content-background-color)
    );
  }
  :host([filled]:not([outline]))
    jha-form-floating-group:not([has-value]):not([has-focus])
    label {
    --jha-form-floating-group-label-top: 32px;
    --jha-form-floating-group-label-left: 9px;
  }
  :host([filled]:not([outline])) {
    --jha-form-date-input-icon-top: 24px;
  }
  :host([filled]:not([outline]))
    [type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
    margin-right: 6px;
  }
  input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
    margin-right: 6px;
  }
  jha-form-floating-group {
    margin-bottom: var(--jha-text-input-margin-bottom, 0);
  }

  /** The native calendar icon cannot be styled in FF so we hide the jha icon */
  @-moz-document url-prefix() {
    jha-icon-date {
      display: none;
    }
  }
`;

/**
 * @element jha-form-date-input-icon
 *
 * Extends Jha-form-input see: forms/jha-form-input-base/jhaFormInput.js for list of properties
 */
export default class JhaFormDateInputIcon extends JhaFormInput {
  static get styles() {
    return [jhaStyles, styles];
  }

  static get properties() {
    return {
      ...super.properties,
      ...{
        min: {
          type: String,
        },
        max: {
          type: String,
        },
      },
    };
  }

  constructor() {
    super();
    this.min = `${new Date().getFullYear() - 120}-01-01`;
    this.max = this.getMaxDate();
    /** @type {import('../jha-form-input-base/JhaFormInput.js').InputType} */
    this.type = 'date';
    this.warning = 'Invalid date';
  }

  getMaxDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  updated(changedProperties) {
    if (changedProperties.has('value_') && this.value !== this.input_.value) {
      this.input_.value = this.value;
    }
  }

  render() {
    return html`
      <div>
        <jha-form-floating-group
          ?outline=${this.outline}
          ?small=${this.small}
          ?filled=${this.filled}
          ?no-label=${this.noLabel}
          .hasValue=${Boolean(this.value)}
          .error=${this.showWarning_() ? this.warning : null}
          .assistiveText=${this.assistiveText}
        >
          <input
            id=${this.id}
            ?required=${this.required}
            ?readonly=${this.readonly}
            ?disabled=${this.disabled}
            type=${this.type}
            minlength=${this.minlength}
            maxlength=${this.maxlength}
            min=${this.min}
            max=${this.max}
            step=${this.step}
            value=${this.value}
            aria-label=${this.label}
            .title=${this.caption}
            @input=${this.onInput_}
            @change=${this.onChange_}
            @blur=${this.onBlur_}
            @keydown=${this.onKeydown_}
            autocomplete=${this.autocomplete}
            placeholder=${this.placeholder}
          />
          <jha-icon-date></jha-icon-date>
          ${this.label
            ? html`
                <label for=${this.id} class="label"
                  >${this.required
                    ? `${this.label} ${this.hideRequiredIndicator ? '' : '*'}`
                    : this.label}</label
                >
              `
            : ''}
        </jha-form-floating-group>
      </div>
    `;
  }
}
